<template>
   <div style="background-color: white">


      <!--<Section background="white"  class="image-bg"-->
      <!--         :style="{'background-image': `url(${require('../../assets/images/content/pexels-brett-sayles-992734-cropped.jpg')})`}"-->

      <!--&gt;-->

      <!--   <nav-bar dark></nav-bar>-->

      <!--   <div class=" main-heading" style=" width: 100%;" >-->
      <!--      <v-container fluid class="heading-line">-->

      <!--         <div class="center display-2">-->
      <!--            私たち-->
      <!--            &lt;!&ndash;about us&ndash;&gt;-->
      <!--         </div>-->
      <!--         &lt;!&ndash;<div class="center display-1">Radio Archive</div>&ndash;&gt;-->


      <!--      </v-container>-->
      <!--   </div>-->


      <!--</Section>-->


      <div style="height: 30px">

      </div>



      <div class="main-content-container">
         <article>

            <table width=100% border="0">
               <tr>
                  <td valign="top">
                     <h1>波平家の自叙伝 </h1> <!-- The Namihira's Biography-->
                     <p> 波平宜精は1952年に日本列島の与那国島で生まれました。彼がまだ一歳の時に、ポリオを患い、その結果、歩くことが非常に困難になりましたが、13歳の時に、足の手術をして、歩くことがずっとたやすくなりました。その事件が、彼がいつか医者になって、他の人々を助けたいという願望を植えつける結果となりました。
                        <!--Yoshinobu Namihira was born in Yonaguni, an island of Japan in 1952.  When he was just one years old, he contracted
                      polio and as a consequence his ability to walk as a child was severely limited.  At the age 13 he had surgery
                      that greatly improved his mobility, an event which instilled in him the desire to become a doctor
                      and help others.  -->
                     </p>
                     <p>
                        彼は1974年に交換大学生徒として、アメリカ合衆国のカリフォルニア州にあるアンバサドア大学に入学しました。そして、1977年にロマリンダ大学で数学専攻で学位を得、その後、医学を続け、1981年に卒業しました。その後、1984年にロマリンダで内科の専門を終え、1986年に、ミシシッピー大学で、胃腸科専門を終えました。
                        <!--Dr. Namihira moved to the US in 1974 as a exchange student, and received his Bachelors in
                      Mathematics from La Sierra College in 1977.  He then studied medicine at Loma Linda University,
                      graduating in 1981, and there after completing his residency in Internal Medicine at Loma Linda
                      in 1984 and then a fellowship in Gastroenterology at the University of Mississippi in 1986. -->
                     </p>
                     <p>
                        波平宜精は、
                        Fellow of the American College of Gastroenterology (FACG) and is a member of the American Board of Internal Medicine, the American College of Gastroenterology, and the American Association for Gastrointestinal Endoscopy　
                        メンバーです。
                        <!--Dr. Namihira is a  Fellow of the American College of Gastroenterology (FACG) and is a member of
                      the American Board of Internal Medicine, the American College of Gastroenterology,
                      and the American Association for Gastroentestinal Endoscopy. -->
                     </p>
                  </td>
                  <td>
                     &nbsp;
                  </td>
                  <td valign="top">
                     <img align="right" src = "../../assets/images/content/dr_mrs_namihira.jpg" width = 250 height=290>
                  </td>
               </tr>
            </table>



            <p>
               波平三枝子は1948年に大阪で生まれ、16歳の時にアメリカに行き、1972年にロマリンダ大学でASCP検査技師として卒業しました。
               波平宜精と三枝子は、1975年に結婚しました。彼はミシシッピー州のビックスバーグ（Vicksburg）で、医者として30年ほど働き、二人で伝道をしています。日本に百万冊ほどの本の配布、アフリカに10万冊ほどの聖書やその他の本の配布、健康講座の講義、短波ラジオ放送（日本、アフリカ、ヨーロッパ、アジア、南アメリカ、中央アメリカ、イスラエル、タヒチ）、また、北アメリカでは、10のFMラジオ放送など、また、刑務所伝道（何万という本の配布）も、20年以上続けています。

               <!--Mieko Namihira was born in 1948 in Osaka Japan.  At the age of 16, she immigrated to the US
             and attended Loma Linda University, graduating in 1972 with her Bachelor degree in Medical Technology.
             She also holds an ASCP certification. -->
            </p>
            <p>
               聖書の預言は、終末の事件を指し示しています。そして、それらの預言が急速に成就しています。人々にその預言の知識を知らせ、来たるべき世の終りの諸事件と、キリストの再臨に関して警告することを唯一の目的としています。
               <!--Dr. and Mrs. Namihira meet while at college and were married in 1975.  Together they reside in Vicksburg, MS
             where Dr. Namihira has had his practice for the past 30 years.  Today the Namihira's have an active ministry
             in which Dr. Namihira lectures on health and Mrs. Namihira runs an international Radio ministry since 1993 which
             covers four continents.   -->
            </p>



         </article>
      </div>




   </div>
</template>

<script>
import navBar from "@/components/navBar";
import Section from "@/components/Section";


export default {
   name: "bibleStudy",
   components: {navBar, Section, },
}
</script>

<style scoped>
.image-bg{
    background-size: cover;
    background-position: center;
    height: 300px;
}

td{
    padding-left: 10px;
    padding-right: 10px;
}


.main-heading{
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;

}


.heading-line{
    text-align: center;
    color:#ffffff;
    /*background-color:rgba(43,43,43,0.4);*/
    width: 100%;

}
</style>